var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 15.6666C4.04665 15.6666 0.833313 12.4533 0.833313 8.49998C0.833313 4.54665 4.04665 1.33331 7.99998 1.33331C11.9533 1.33331 15.1666 4.54665 15.1666 8.49998C15.1666 12.4533 11.9533 15.6666 7.99998 15.6666ZM7.99998 2.33331C4.59998 2.33331 1.83331 5.09998 1.83331 8.49998C1.83331 11.9 4.59998 14.6666 7.99998 14.6666C11.4 14.6666 14.1666 11.9 14.1666 8.49998C14.1666 5.09998 11.4 2.33331 7.99998 2.33331Z",
    fill: "#001F4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4733 11.12C10.3867 11.12 10.3 11.1 10.22 11.0467L8.15334 9.81332C7.64001 9.50665 7.26001 8.83332 7.26001 8.23999L7.26001 5.50665C7.26001 5.23332 7.48668 5.00665 7.76001 5.00665C8.03334 5.00665 8.26001 5.23332 8.26001 5.50665V8.23999C8.26001 8.47999 8.46001 8.83332 8.66668 8.95332L10.7333 10.1867C10.9733 10.3267 11.0467 10.6333 10.9067 10.8733C10.8067 11.0333 10.64 11.12 10.4733 11.12Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.13cd8ccf311b6d9ae4fa04a114a3f4d7.svg";
export { ForwardRef as ReactComponent };